import { Device } from '@capacitor/device'
import { combine, createDomain, sample } from 'effector'
import { createGate } from 'effector-react'
import { $token } from '~/entities/viewer/model'
import { AxiosErrorType, Notifications } from '~/shared/api'
import { NotificationTokenTypes } from '~/shared/config/enums'

export const Gate = createGate()

const domain = createDomain('entities.notifications')

type NotificationsData = {
  notificationToken: string
  tokenType: NotificationTokenTypes
}

export const setPushNotificationsData = domain.createEvent<NotificationsData>()
const $pushNotificationsData = domain
  .createStore<NotificationsData | null>(null)
  .on(setPushNotificationsData, (_, data) => data)

export const $tokenType = $pushNotificationsData.map((data) => data?.tokenType)

export const pushNotificationTokensFx = domain.createEffect<
  NotificationsData,
  void,
  AxiosErrorType
>({
  async handler({ notificationToken, tokenType }) {
    const deviceId = await Device.getId()

    const pushTokens = new Notifications.PushTokens({
      token: notificationToken,
      deviceId: deviceId.identifier,
      tokenType: tokenType,
    })
    await pushTokens.save()
  },
})

const $combinedToken = combine({
  token: $token,
  notificationsData: $pushNotificationsData,
})

sample({
  clock: $combinedToken,
  filter: ({ token, notificationsData }) =>
    Boolean(notificationsData?.notificationToken) && Boolean(token),
  fn: ({ notificationsData }) => notificationsData as NotificationsData,
  target: pushNotificationTokensFx,
})
